<script setup lang="ts">
import { useQuery } from '@urql/vue';
import { graphql } from '@/gql';
import NoServicesInCart from '../components/NoServicesInCart.vue';
import CartServiceWorkPlaceDetailedGroup from '../components/CartServiceWorkPlaceDetailedGroup.vue';

useHead({ title: 'Корзина' });

const { data: queryData } = useQuery({
  query: graphql(/* GraphQL */ `
    query Cart_CartMastersQuery {
      cartMasters {
        id
        workPlaces {
          id
          ...CartServiceWorkPlaceDetailedGroup_MasterWorkPlaceFragment
        }
      }
    }
  `),
});
const workPlaces = toRef(() =>
  queryData.value?.cartMasters.flatMap((master) => master.workPlaces)
);
</script>

<template>
  <div>
    <NuxtLayout
      name="app"
      title="Корзина"
      :header-background="{ xs: 'camouflage', md: 'white' }"
    >
      <template #grid-prepend>
        <h1>Корзина</h1>
      </template>
      <template #sidebar>
        <AppInfoWindow :model-value="true" :closable="false">
          Оплата происходит вне сервиса, вам нужно будет договориться об удобном
          способе оплате с мастером
        </AppInfoWindow>
      </template>

      <AppInfoWindow class="d-lg-none" :model-value="true" :closable="false">
        Оплата происходит вне сервиса, вам нужно будет договориться об удобном
        способе оплате с мастером
      </AppInfoWindow>

      <div class="no-services">
        <NoServicesInCart v-if="!workPlaces?.length" />
      </div>
      <div class="d-flex flex-column gap-6">
        <CartServiceWorkPlaceDetailedGroup
          v-for="workPlace in workPlaces"
          :key="workPlace.id"
          :work-place="workPlace"
        />
      </div>
    </NuxtLayout>
  </div>
</template>

<style scoped lang="scss">
@import '@glow/shared/assets/core.scss';

.no-services {
  display: flex;
  justify-content: center;
}
</style>
